import { api } from "@/api";
import {
  invalidateStorageQueries,
  type StorageBooking,
  type StorageBookingInput,
} from "./storage";

export const updateStorageBooking = async (
  bookingId: string,
  input: StorageBookingInput,
) => {
  const { body } = await api.put<StorageBooking>(
    `/storage/bookings/${bookingId}`,
    { body: input },
  );
  invalidateStorageQueries();
  return body;
};
